var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwords(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6970_542696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5738 20.0001C19.3365 19.9427 19.9427 19.3365 20.0001 18.5738L16.7925 15.3662L15.3662 16.7925L18.5738 20.0001Z",
    fill: "#6C53E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7322 12.8699L12.7188 14.6019L13.8939 15.6127L12.8625 16.6442L13.5253 17.3071L17.3073 13.5252L16.6444 12.8623L15.6129 13.8938L14.7322 12.8699Z",
    fill: "#6C53E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3817 8.97491L7.40753 4.35472L4 4L4.35472 7.40753L9.16834 11.5481L11.3817 8.97491Z",
    fill: "#6C53E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18.5738C4.05731 19.3365 4.66356 19.9427 5.42625 20.0001L8.63384 16.7925L7.20759 15.3662L4 18.5738Z",
    fill: "#6C53E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38673 13.894L7.35526 12.8625L6.69238 13.5254L10.4743 17.3073L11.1372 16.6444L10.1057 15.613L19.645 7.40753L19.9997 4L16.5922 4.35472L8.38673 13.894Z",
    fill: "#6C53E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6970_542696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwords);
export default __webpack_public_path__ + "static/media/swords.64675a930cf053120e01d160895f3671.svg";
export { ForwardRef as ReactComponent };